import {
  SetStockAlertRequest,
  setStockAlertRequestOutputTransformer,
} from '../interfaces/StockAlert/SetStockAlertRequest';
import api, { apiPrefix } from './Api';

export const setStockAlert = async (req: SetStockAlertRequest): Promise<void> =>
  api.post(
    `${apiPrefix}/stock-alert`,
    setStockAlertRequestOutputTransformer(req),
  );
